<template>
<m-pageframe
    title="{organization-label}: Lightbox Settings"
>
<v-container
    fluid
>
    <m-beta-alert
        code="lightboxes"
        description="<b>Heads up!</b><br/><br/>Lightboxes are still new (i.e. in 'beta'). This feature allows you to create popup forms and messages for your website. We have done our best to test this feature out thoroughly, but it <i>might</i> still have a few bugs.  We are eager to get your feedback."
    />


    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
    >
        <v-menu
            bottom
            offset-y
            slot="append-outer"
        >
            <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
            </template>
    
            <v-list>
                <v-list-item
                    v-on:click="$rc.$state.isOrganizationAdmin() ? onClickNew() : null"
                    :disabled="!$rc.$state.isOrganizationAdmin()"
                >
                    <v-list-item-title>New Lightbox...</v-list-item-title>
                </v-list-item>

                <v-divider/>

                <v-list-item
                    v-on:click="$rc.$state.isOrganizationAdmin() ? onClickURLs() : null"
                    :disabled="!$rc.$state.isOrganizationAdmin()"
                >
                    <v-list-item-title>Edit Lightbox URL(s)...</v-list-item-title>
                </v-list-item>

            </v-list>
        </v-menu> 
    </v-text-field>
       

    <m-boolean-search-filter
        style="margin-top: 5px; margin-left: 10px;"
        label="Archived"
        v-model="filter_archived"
    />

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
        <template v-slot:item.archived="{ item }">
            <v-simple-checkbox
                disabled
                :value="item.archived"
            />
                
        </template>
    
        <template v-slot:item.comp_display_delay_ms="{ item }">
            {{item.comp_display_delay_ms == null ? null : item.comp_display_delay_ms/1000}}
        </template>

        <template v-slot:item.hide_display_duration_ms="{ item }">
            {{item.hide_display_duration_ms == null ? 24 : Math.round(item.hide_display_duration_ms / (60 * 60 * 1000))}}
        </template>

        <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical-circle-outline
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-on:click="$rc.$state.isOrganizationAdmin() ? onClickEdit(item) : null"
                    :disabled="!$rc.$state.isOrganizationAdmin()"
                >
                    <v-list-item-title>Edit...</v-list-item-title>
                </v-list-item>

                <v-divider/>

                <v-list-item
                    v-on:click="$rc.$state.isOrganizationAdmin() ? onClickToggleArchvied(item) : null"
                    :disabled="!$rc.$state.isOrganizationAdmin()"
                >
                    <v-list-item-title>{{item.archived ? 'Unarchive' : 'Archive'}}</v-list-item-title>
                </v-list-item>

                <v-divider/>

                <v-list-item
                    v-on:click="$rc.$state.isOrganizationAdmin() ? onClickShowAlways(item) : null"
                    :disabled="!$rc.$state.isOrganizationAdmin() || item.comp_visibility == 'all-pages' || item.archived == true"
                >
                    <v-list-item-title
                    >
                        Show on every page...
                    </v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="$rc.$state.isOrganizationAdmin() ? onClickShowNever(item) : null"
                    :disabled="!$rc.$state.isOrganizationAdmin() || item.comp_visibility == 'never' || item.archived == true"
                >
                    <v-list-item-title
                    >
                        Never show...
                    </v-list-item-title>
                </v-list-item>

                <v-divider/>

                <v-list-item
                    v-on:click="$rc.$state.isOrganizationAdmin() ? onClickSetUniformDelay(item) : null"
                    :disabled="!$rc.$state.isOrganizationAdmin() || item.comp_visibility == 'never' || item.archived == true"
                >
                    <v-list-item-title
                    >
                        Set uniform display delay...
                    </v-list-item-title>
                </v-list-item>



            </v-list>
            
            </v-menu> 
        </template>
    
    </v-data-table>

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');

export default {

    data() {
        return {
            lightboxes: null,
            full_text: null,
            filter_archived: null,

            headers: [
                { text: 'Archived', value: 'archived'},
                { text: 'Label', value: 'label'},
                { text: 'Shows', value: 'comp_visibility'},
                { text: 'Display Delay (type)', value: 'comp_display_delay_type'},
                { text: 'Display Delay (sec)', value: 'comp_display_delay_ms'},
                { text: 'Show Once Per (hrs)', value: 'hide_display_duration_ms'},
                { text: 'Action', value: 'action'},
            ],
        }
    },

    mounted () {
        this.update();
    },

    methods: {
        update() {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET:/api/v1/lightbox/organization/:organization_id',
            
                'params' : {
                        'organization_id': this.$route.params.organization_id,
                    },
            
                'on_success': (data) => {
                        this.lightboxes = _.cloneDeep(data);
                    },
            
                'on_error': 'Unable to list lightbox settings',
            });
        },

        onClickEdit(item)
        {
            this.$router.push({
                'name': 'lightbox-edit',
                'params' : {
                    'organization_id': item.organization_id,
                    'lightbox_id': item.lightbox_id,
                }
            });
        },

        onClickNew()
        {
            this.$rc.prompt({
                'title': 'Create New Lightbox',
                'label': 'Enter a label for the new lightbox',
                'value': null,
                'unset_label': null,
            
                'after_prompt': (value) => {
                    this.doCreateNew(value);
                },
            });
        },

        doCreateNew(label)
        {
            if ( label == null ) label = '';
            if ( label.trim().length == 0 ) return;

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/lightbox/settings/create-stub',
            
                'params' : {
                        'organization_id': this.$route.params.organization_id,
                        'label': label,
                    },
            
                'on_success': (data) => {
                        this.onClickEdit(data);
                    },
            
                'on_error': 'Unable to create new lightbox',
            });
        },

        onClickToggleArchvied(item)
        {
            let patch = {
                'lightbox_id': item.lightbox_id,
                'archived': !item.archived,
            };

            this.patch(patch);
        },

        patch(patch)
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PATCH: /api/v1/lightbox',
            
                'params' : patch,
            
                'on_success': (data) => {
                        this.update();
                    },
            
                'on_error': 'Unable to patch lightbox settings',
            });
        },

        onClickShowAlways(item)
        {
            this.$rc.confirm({
                'title': 'Show Lightbox on Every Page',
                'body': 'Show "'+item.label+'" on every page?  All other lightboxes will be set to never show',
                'btn_text_ok': 'Show on every page',
                'btn_text_cancel': 'Cancel',
                'on_ok': () => {
                    this.doClickShowAlways(item);
                },
            });
        },

        doClickShowAlways(item)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/lightbox/urls/show-on-all-pages',
            
                'params' : {
                        'lightbox_id': item.lightbox_id,
                    },
            
                'on_success': (data) => {
                        this.update();
                    },
            
                'on_error': 'Unable to show lightbox on every page',
            });
        },

        onClickShowNever(item)
        {
            this.$rc.confirm({
                'title': 'Never Show Lightbox',
                'body': 'Never show "'+item.label+'"?',
                'btn_text_ok': 'Never Show',
                'btn_text_cancel': 'Cancel',
                'on_ok': () => {
                    this.doClickShowNever(item);
                },
            });
        },

        doClickShowNever(item)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/lightbox/urls/never-show',
            
                'params' : {
                        'lightbox_id': item.lightbox_id,
                    },
            
                'on_success': (data) => {
                        this.update();
                    },
            
                'on_error': 'Unable to set lightbox to never show',
            });
        },

        onClickSetUniformDelay(item)
        {
            let initial_value = (item.comp_display_delay_ms ?? 0) / 1000;

            this.$rc.prompt({
                'title': 'Set uniform display delay',
                'label': 'Set a uniform delay (in seconds) before showing the lightbox. ',
                'value': initial_value,
                'unset_label': null,
                'is_valid': this.$rc.validationRuleInteger(1,null),
            
                'after_prompt': (value) => {
                    this.doSetUniformDelay(item, value*1000);
                },
            });
        },

        doSetUniformDelay(item, delay_ms)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/lightbox/urls/set-uniform-display-delay',

                'params' : {
                        'lightbox_id': item.lightbox_id,
                        'delay': delay_ms,
                    },

                'on_success': (data) => {
                        this.update();
                    },

                'on_error': 'Unable to set uniform lightbox display delay.',
            });
        },



        onClickURLs()
        {
            this.$router.push({
                'name': 'lightbox-urls',
                'params' : {
                    'organization_id': this.$route.params.organization_id,
                }
            });
        },
    },

    computed: {
        results() {

            if ( this.lightboxes == null )
                return [];

            let full_text = this.full_text;

            if ( full_text == null ) full_text = '';
            full_text = full_text.trim().toLowerCase();

            let all_settings = this.lightboxes.settings;

            let filter_full_text = (item) => {
                return item.label.toLowerCase().includes(full_text);
            };

            let filter_archived = (item) => {
                if ( this.filter_archived == null )
                    return true;

                return item.archived == this.filter_archived;
            };

            return all_settings
                .filter(filter_full_text)
                .filter(filter_archived);
        }
    },

}
</script>

<style lang="scss" scoped>
</style>